import React from 'react';
import Loading from '~/components/atom/Loading';

type Props = {
  eventId: string;
};

/**
 * LFA-specific FullEmailMessage.
 * TODO: Wire up useGetExtendedEmailQuery for LFA when BE implements it.
 * Replace the placeholder below with the actual query + rendering.
 */
const FullEmailMessage: React.FC<Props> = ({}) => <Loading />;

export default FullEmailMessage;
